import { render, staticRenderFns } from "./PermissionEditPage.vue?vue&type=template&id=41d7fc44"
import script from "./PermissionEditPage.vue?vue&type=script&lang=ts"
export * from "./PermissionEditPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports